import React, {useState} from "react";
import {
    Typography,
    Grid,
    Button,
    makeStyles,
    Container
} from "@material-ui/core";
import welcomeImage from "../../../Images/welcomeImage.webp";
import {ReactComponent as SubscriptionSVG} from "../../../Images/welcomeSubscriptionImage.svg";
import {useHistory} from "react-router-dom";
import {statesWithoutPrescription} from "../../../Constants/locations";
import {useEffect} from "react";
import {useSelector} from "react-redux";
import {RootState} from "../../../redux/store";
import API from "../../../helpers/apiHelpers";
import {fetchAndApplyAppointmentDraft, getGuestBookingResumePath} from "../../../utils/guestBooking";
import Image from "material-ui-image";

interface Props {
    pet: any;
    isOnBoarding: boolean;
    setIsOnBoarding: React.Dispatch<React.SetStateAction<boolean>>;
    hasSubscription?: boolean;
}

const useStyle = makeStyles(() => ({
    body: {
        paddingTop: 20,
    },
    spacing: {
        paddingTop: 20,
    },
    spacingImage: {
        paddingTop: 50,
        paddingBottom: 40,
        display: "flex",
        justifyContent: "center"
    },
}));

const toProperCase = (value: string) =>
    value
        .trim()
        .toLowerCase()
        .replace(/\b\w/g, character => character.toUpperCase());

const formatPetNames = (pets: any[]) => {
    const names = pets
        .map(item => item?.name)
        .filter(Boolean)
        .map(toProperCase);

    if (names.length === 0) {
        return "your pet";
    }

    if (names.length === 1) {
        return names[0];
    }

    if (names.length === 2) {
        return `${names[0]} and ${names[1]}`;
    }

    return `${names.slice(0, -1).join(", ")}, and ${names[names.length - 1]}`;
};

const Offer = ({pet, isOnBoarding, setIsOnBoarding, hasSubscription = false}: Props) => {
    let history = useHistory();
    const classes = useStyle();
    const location = useSelector((state: RootState) => state?.common.location);
    const [bundle, setBundle] = useState(false);
    const isWhiteLabel = useSelector((state: RootState) => state?.branding.partnerPreferencesOn);
    const logo = useSelector((state: RootState) => state?.branding.logo);
    const pets = Array.isArray(pet) ? pet : pet ? [pet] : [];
    const petNames = formatPetNames(pets);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        if (location) {
            setBundle(!statesWithoutPrescription.some(item => item.value === location));
        }
    }, [location]);

    return (
        <Container className={classes.body} disableGutters={true}>
            <Grid container>
                <Grid item xs={12}>
                    <Typography variant="h2">
                        Congratulations you are all set up!
                    </Typography>
                </Grid>
                <Grid item xs={12} className={classes.spacingImage}>
                    {hasSubscription ? <SubscriptionSVG style={{width: "100%"}}/> :
                        isWhiteLabel ?
                            <Image
                                alt="pet image"
                                src={pet.imageUrl}
                                errorIcon={<img alt="error icon" src={logo} width="100%"/>}
                                style={{width: "50%", paddingTop: 0, position: "relative"}}
                                imageStyle={{height: "100%", position: "relative"}}/>:
                            <img src={welcomeImage} alt="" style={{width: "100%", display: "block"}} />}
                </Grid>
                {!hasSubscription &&
                <>
                    <Grid item xs={12}>
                        <Typography variant="h5" className={classes.spacing}>
                            {bundle ?
                                (isWhiteLabel ?
                                    "We are so excited for you to meet our amazing veterinarians!"
                                    :
                                    `We are excited you’re here and can’t wait to meet ${petNames}`
                                )
                                : `We are excited you’re here and can’t wait to meet ${petNames}`}
                        </Typography>
                    </Grid>
                </>
                }
                {bundle && !hasSubscription && !isWhiteLabel &&
                <Grid item xs={12} className={classes.spacing}>
                    <Button
                        type="button"
                        fullWidth
                        color="secondary"
                        variant="outlined"
                        onClick={() => {
                            history.push("/purchaseCredits");
                        }}
                    >
                        Learn More & Save
                    </Button>
                </Grid>
                }
                <Grid item xs={12} className={classes.spacing}>
                    <Button
                        type="button"
                        fullWidth
                        color="primary"
                        variant="contained"
                        onClick={async () => {
                            if (isOnBoarding) {
                                setIsOnBoarding(false);
                                document.cookie = "isOnBoarding= ; expires=Thu, 01 Jan 1970 00:00:00 UTC;";
                            }
                            await fetchAndApplyAppointmentDraft();
                            history.push(getGuestBookingResumePath() || "/schedule");
                        }}
                    >
                        Book Now
                    </Button>
                </Grid>
            </Grid>
        </Container>
    );
};

export default Offer;
